import { Component, OnInit } from '@angular/core';
import { platformList, sportList } from '../shared.service';
import { CommonService } from '../providers/common.service';
import { NavService } from '../providers/nav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private commonService: CommonService,
    private navService: NavService,
    public router: Router

  ) {
    const user: any = JSON.parse(localStorage.getItem('userDetails'))
    if (user && user.isLogin) {
      this.router.navigateByUrl('DashBoard');
    }
  }

  ngOnInit(): void {
  }


  forwordDashboard() {
    const user: any = JSON.parse(localStorage.getItem('userDetails'))
    if (user && user.isLogin) {
      this.router.navigateByUrl('DashBoard');
    } else {
      const data = {
        isLogin: false,
        isSkip: true,
        platformName: platformList[platformList.DraftKings],
        sportName: sportList[sportList.NFL],
        default_platform_id: platformList.DraftKings,
        default_sport_id: sportList.NFL
      };
      this.commonService.platformandsport.sport_id = sportList.NFL;
      this.commonService.platformandsport.platform_id = platformList.DraftKings;
      localStorage.setItem('userDetails', JSON.stringify(data));
      //this.navService.changeNav('item');
      this.navService.changeNavHeaderActive('/Board');
      this.router.navigate(['/Board']);
    }

  }
}
